'use strict';
define([], function () {
    var wizardTemplate = `
<div class="m-t-lg"
     ng-class="{
        'wizard-step--single': viewMode !== 'full',
        'wizard-step--crawl': viewMode === 'crawl',
        'wizard-step--schedule': viewMode === 'schedule'
     }"
     layout="column"
     layout-align="center center">
    <div class="max-w-xxxl">
        <div class="st-white-raised">
            <div class="wizard-step__grid">
                <section class="wizard-step__col" ng-if="viewMode === 'schedule'">
                    <div class="wizard-step__row wizard-step__decision wizard-step__decision--primary"
                         ng-class="{'is-selected': schedule.runScheduled}">
                        <div class="wizard-step__copy">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-calendar-repeat" aria-hidden="true"></i>
                            </span>
                            <span class="wizard-step__copy-text">
                                <span class="wizard-step__label">{{'project.wizard.run.scheduled.crawls' | translate}}</span>
                                <small class="wizard-step__hint">{{'project.wizard.newFlow.scheduledHint' | translate}}</small>
                            </span>
                        </div>
                        <md-switch class="m-0" ng-model="schedule.runScheduled"
                                   aria-label="{{'project.wizard.run.scheduled.crawls' | translate}}"></md-switch>
                    </div>

                    <div class="wizard-step__row wizard-step__decision" ng-if="schedule.runScheduled">
                        <div class="wizard-step__copy">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-repeat" aria-hidden="true"></i>
                            </span>
                            <span class="wizard-step__copy-text">
                                <span class="wizard-step__label">{{'project.wizard.frequency' | translate}}</span>
                                <small class="wizard-step__hint">{{'project.wizard.newFlow.frequencyHint' | translate}}</small>
                            </span>
                        </div>
                        <md-input-container class="m-0">
                            <md-select aria-label="{{'project.wizard.frequency' | translate}}"
                                       class="sto-icon-select md-body-1 f-w-500 st-blue md-no-underline md-select--blue"
                                       ng-model="schedule.scheduleFrequency">
                                <md-option ng-value="'daily'">{{'Daily' | translate}}</md-option>
                                <md-option ng-value="'weekly'">{{'Weekly' | translate}}</md-option>
                                <md-option ng-value="'monthly'">{{'Monthly' | translate}}</md-option>
                            </md-select>
                        </md-input-container>
                    </div>

                    <div class="wizard-step__first-scan">
                        <div class="wizard-step__first-scan-heading">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-bolt" aria-hidden="true"></i>
                            </span>
                            <span>
                                <strong>{{'project.wizard.run.first.crawl.now' | translate}}</strong>
                                <small>{{'project.wizard.newFlow.firstScanHint' | translate}}</small>
                            </span>
                        </div>
                        <div class="wizard-step__scan-options"
                             role="group"
                             aria-label="{{'project.wizard.run.first.crawl.now' | translate}}">
                            <button type="button"
                                    class="wizard-step__scan-option"
                                    ng-class="{'is-selected': schedule.crawlerNow}"
                                    ng-attr-aria-pressed="{{schedule.crawlerNow}}"
                                    ng-click="schedule.crawlerNow = true">
                                <span class="wizard-step__scan-option-icon">
                                    <i class="ti ti-player-play" aria-hidden="true"></i>
                                </span>
                                <span>
                                    <strong>{{'project.wizard.newFlow.startScanNow' | translate}}</strong>
                                    <small>{{'project.wizard.newFlow.startScanNowHint' | translate}}</small>
                                </span>
                                <i class="ti ti-circle-check" ng-if="schedule.crawlerNow" aria-hidden="true"></i>
                            </button>
                            <button type="button"
                                    class="wizard-step__scan-option"
                                    ng-class="{'is-selected': !schedule.crawlerNow}"
                                    ng-attr-aria-pressed="{{!schedule.crawlerNow}}"
                                    ng-click="schedule.crawlerNow = false">
                                <span class="wizard-step__scan-option-icon">
                                    <i class="ti ti-calendar-time" aria-hidden="true"></i>
                                </span>
                                <span>
                                    <strong>{{'project.wizard.newFlow.startScanLater' | translate}}</strong>
                                    <small>{{'project.wizard.newFlow.startScanLaterHint' | translate}}</small>
                                </span>
                                <i class="ti ti-circle-check" ng-if="!schedule.crawlerNow" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </section>

                <section class="wizard-step__col" ng-if="viewMode === 'crawl'">
                    <div class="wizard-step__row wizard-step__decision">
                        <div class="wizard-step__copy">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-shield-check" aria-hidden="true"></i>
                            </span>
                            <span class="wizard-step__copy-text">
                                <span class="wizard-step__label">{{'project.wizard.respect.robots.rules' | translate}}</span>
                                <small class="wizard-step__hint">{{'project.wizard.newFlow.robotsHint' | translate}}</small>
                            </span>
                        </div>
                        <md-switch class="m-0" ng-model="schedule.respectRobots"
                                   aria-label="{{'workspace.respectRobotsSwitchAria' | translate}}"></md-switch>
                    </div>

                    <div class="wizard-step__row">
                        <div class="wizard-step__copy">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-stack-2" aria-hidden="true"></i>
                            </span>
                            <span class="wizard-step__copy-text">
                                <span class="wizard-step__label">{{'project.wizard.total.resources' | translate}}</span>
                                <small class="wizard-step__hint">{{'project.wizard.newFlow.resourcesHint' | translate}}</small>
                            </span>
                        </div>
                        <md-input-container class="m-0">
                            <md-select aria-label="{{'workspace.scheduleResourcesAria' | translate}}"
                                       class="sto-icon-select md-body-1 f-w-500 st-blue md-no-underline md-select--blue"
                                       ng-model="schedule.resourcesLimit"
                                       ng-change="onResourcesLimitChange(schedule.resourcesLimit)">
                                <md-option class="st-blue md-body-1 f-w-500 wizard-step__resource-option"
                                           ng-repeat="resource in resources track by resource.value"
                                           ng-value="resource.value">
                                    <span>{{resource.value|number}} {{'seospider.resources' | translate}}</span>
                                    <span class="wizard-step__resource-upgrade" ng-if="resource.locked">
                                        {{'upgrade.to.unlock' | translate}}
                                        <i class="ti ti-arrow-up-right" aria-hidden="true"></i>
                                    </span>
                                </md-option>
                            </md-select>
                        </md-input-container>
                    </div>

                    <div class="wizard-step__row">
                        <div class="wizard-step__copy">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-robot" aria-hidden="true"></i>
                            </span>
                            <span class="wizard-step__copy-text">
                                <span class="wizard-step__label">{{'project.wizard.user.agent' | translate}}</span>
                                <small class="wizard-step__hint">{{'project.wizard.newFlow.userAgentHint' | translate}}</small>
                            </span>
                        </div>
                        <md-input-container class="m-0">
                            <md-select aria-label="{{'workspace.scheduleUserAgentAria' | translate}}"
                                       class="sto-icon-select md-body-1 f-w-500 st-blue md-no-underline md-select--blue"
                                       ng-model="schedule.userAgent">
                                <md-option ng-value="'STO'">SEO Tester Bot</md-option>
                                <md-option ng-value="'GOOGLEBOT'">GoogleBot</md-option>
                                <md-option ng-value="'GOOGLEBOT_MOBILE'">GoogleBot Mobile</md-option>
                                <md-option ng-value="'GOOGLEBOT_SMARTPHONE'">GoogleBot Smartphone</md-option>
                                <md-option ng-value="'BING'">BingBot</md-option>
                                <md-option ng-value="'CHROME'">Chrome</md-option>
                                <md-option ng-value="'FIREFOX'">Firefox</md-option>
                            </md-select>
                        </md-input-container>
                    </div>

                    <div class="wizard-step__row">
                        <div class="wizard-step__copy">
                            <span class="wizard-step__item-icon">
                                <i class="ti ti-gauge" aria-hidden="true"></i>
                            </span>
                            <span class="wizard-step__copy-text">
                                <span class="wizard-step__label">{{'project.wizard.schedule.speed' | translate}}</span>
                                <small class="wizard-step__hint">{{'project.wizard.newFlow.speedHint' | translate}}</small>
                            </span>
                        </div>
                        <md-input-container class="m-0">
                            <md-select aria-label="{{'workspace.scheduleSpeedAria' | translate}}"
                                       class="sto-icon-select md-body-1 f-w-500 st-blue md-no-underline md-select--blue"
                                       ng-model="schedule.speed">
                                <md-option ng-value="1">{{'seospider.ultra.slow' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '0.1'} }}</md-option>
                                <md-option ng-value="2">{{'seospider.very.slow' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '0.2'} }}</md-option>
                                <md-option ng-value="3">{{'seospider.slow' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '1'} }}</md-option>
                                <md-option ng-value="4">{{'seospider.moderate' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '5'} }}</md-option>
                                <md-option ng-value="5">{{'seospider.normal' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '10'} }}</md-option>
                                <md-option ng-value="6">{{'seospider.fast' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '15'} }}</md-option>
                                <md-option ng-value="7">{{'seospider.very.fast' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '25'} }}</md-option>
                                <md-option ng-value="8">{{'seospider.ultra.fast' | translate}} · {{'workspace.pagesPerSecond' | translate:{value: '50'} }}</md-option>
                            </md-select>
                        </md-input-container>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>`;

    function controller(
        $scope,
        $element,
        $filter,
        $mdMedia,
        $translate,
        $mdToast,
        $stateParams,
        $state,
        TrackEventService,
        $rootScope,
        UserService,
        $q,
        TimezoneService,
        PlanDetailsService,
        CRMService,
    ) {
        var ctrl = this;
        var resources = [10, 25, 50, 100, 150, 200, 250, 500, 1000, 1500, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 20000, 50000, 100000];

        if ($element) {
            $element.addClass('schedule-ctrl-live');
        }

        /* I binding possono non essere ancora copiati su `this` quando il
           costruttore viene eseguito: gli attributi restano la fonte di verità. */
        var rawViewMode = $element && ($element.attr('view-mode') || $element.attr('viewmode'));
        rawViewMode = rawViewMode && rawViewMode.replace(/^['"]|['"]$/g, '');
        if (rawViewMode) {
            ctrl.viewMode = rawViewMode;
            $scope.viewMode = ctrl.viewMode;
        }
        if (ctrl.wizardMode === undefined && $element) {
            ctrl.wizardMode = $element.attr('wizard-mode') === 'true';
        }
        var parentSchedule = $scope.$parent && $scope.$parent.schedule;
        if (!ctrl.schedule && parentSchedule) {
            ctrl.schedule = parentSchedule;
            $scope.schedule = parentSchedule;
        }
        if ($scope.$parent && $scope.$parent.step !== undefined) {
            $scope.viewMode = Number($scope.$parent.step) === 4 ? 'schedule' : 'crawl';
            ctrl.viewMode = $scope.viewMode;
            $scope.$parent.$watch('step', function (step) {
                $scope.viewMode = Number(step) === 4 ? 'schedule' : 'crawl';
                ctrl.viewMode = $scope.viewMode;
            });
        }
        syncBindings();
        $scope.resources = resources.map(function (resource) {
            return {
                value: resource,
                locked: false
            };
        });

        $scope.$mdMedia=$mdMedia;
        $scope.resources = [];
        $scope.showCustomToast = showCustomToast;
        $scope.onResourcesLimitChange = onResourcesLimitChange;

        function showCustomToast(string, classIcon) {
            $mdToast.show({
                template:
                    '<md-toast layout="row" flex class="md-toast max-w">' +
                    '   <div class="p-t p-b"><i class="' + classIcon + ' m-r-sm"></i>' + $translate.instant(string) + '</div>' +
                    '</md-toast>',
                hideDelay: 5000,
                position: 'top right',
                parent: angular.element('.toast-show')
            });
        }

        function getUserMaxResources() {
            var dfd = $q.defer();
            var readLimits = function (res) {
                if (!res || !res.data || !res.data.limits || !res.data.limits.length) {
                    return null;
                }
                var limit = null;
                angular.forEach(res.data.limits, function (service) {
                    if (service.alias === 'seo-spider-limit' && service.qtyAllowed) {
                        limit = Number(service.qtyAllowed);
                    }
                });
                return limit;
            };
            UserService.limits()
                .then(function (res) {
                    var planLimit = readLimits(res);
                    if (planLimit) {
                        dfd.resolve(planLimit);
                        return null;
                    }
                    return UserService.sessionInfo().then(function (session) {
                        dfd.resolve(readLimits(session) || 15);
                    });
                })
                .catch(function () {
                    return UserService.sessionInfo().then(function (session) {
                        dfd.resolve(readLimits(session) || 15);
                    }).catch(function () {
                        dfd.resolve(15);
                    });
                });

            return dfd.promise;
        }

        function syncBindings() {
            var schedule = ctrl.schedule || ($scope.$parent && $scope.$parent.schedule);
            if (schedule) {
                ctrl.schedule = schedule;
                $scope.schedule = schedule;
            }
            ctrl.viewMode = ctrl.viewMode ||
                ($element && ($element.attr('view-mode') || $element.attr('viewmode'))) ||
                'full';
            $scope.viewMode = ctrl.viewMode;
            if (ctrl.wizardMode === undefined && $element) {
                ctrl.wizardMode = $element.attr('wizard-mode') === 'true';
            }
            $scope.wizardMode = ctrl.wizardMode;
        }

        this.$onInit = function () {
            $element.attr('data-oninit-ran', 'true');
            try {
            syncBindings();
            $scope.booleanOptions = [
                {value: true, label: 'yes'},
                {value: false, label: 'no'}
            ];
            $scope.times = TimezoneService.getAllTimeOptions();
            $scope.timezones = TimezoneService.getAllTimezoneOptions();
            $scope.frequencyOptions = [
                {value: 'daily', label: 'Daily'},
                {value: 'weekly', label: 'Weekly'},
                {value: 'monthly', label: 'Monthly'}
            ];
            $scope.stepSchedule = 'scheduleExam';

            if ($scope.schedule && $scope.schedule.runScheduled) {
                $scope.schedule.runScheduled = true;
            }

            $scope.maxResources = 15;
            getUserMaxResources()
                .then(function (maxResources) {
                    $scope.maxResources = Number(maxResources) || 15;
                    var values = resources.slice();
                    if (values.indexOf($scope.maxResources) === -1) {
                        values.push($scope.maxResources);
                    }
                    $scope.resources = values
                        .sort(function (a, b) { return a - b; })
                        .map(function (resource) {
                            return {
                                value: resource,
                                locked: resource > $scope.maxResources
                            };
                        });

                    if (!$scope.schedule) {
                        return;
                    }

                    if (!$scope.schedule.resourcesLimit) {
                        $scope.schedule.resourcesLimit = snapToAllowed(100);
                        $scope.lastAllowedResourcesLimit = $scope.schedule.resourcesLimit;
                        return;
                    }

                    /* Valori fuori lista (o oltre il piano) riportati all'opzione
                       consentita più vicina. */
                    var requestedLimit = Number($scope.schedule.resourcesLimit);
                    if (requestedLimit > $scope.maxResources ||
                        !$scope.resources.some(function (resource) {
                            return !resource.locked && resource.value === requestedLimit;
                        })) {
                        $scope.schedule.resourcesLimit = snapToAllowed(requestedLimit);
                    }
                    $scope.lastAllowedResourcesLimit = $scope.schedule.resourcesLimit;
                });

        /* L'opzione consentita più vicina al valore richiesto (mai oltre il piano). */
        function snapToAllowed(value) {
            var allowed = $scope.resources.filter(function (resource) {
                return !resource.locked;
            });
            var best = allowed.length ? allowed[0].value : 10;
            angular.forEach(allowed, function (resource) {
                if (resource.value <= value) {
                    best = resource.value;
                }
            });
            return best;
        }

        function getPlanForResources(resourcesLimit) {
            var eligiblePlans = (PlanDetailsService.plans || []).filter(function (plan) {
                var features = plan.features && plan.features[0];
                var audit = features && features.onSiteSeoAudit;
                return audit && Number(audit.pagesCanBeAnalyzedByProject) >= resourcesLimit;
            });

            return eligiblePlans.sort(function (firstPlan, secondPlan) {
                return firstPlan.features[0].onSiteSeoAudit.pagesCanBeAnalyzedByProject -
                    secondPlan.features[0].onSiteSeoAudit.pagesCanBeAnalyzedByProject;
            })[0];
        }

        function onResourcesLimitChange(resourcesLimit) {
            var requestedLimit = Number(resourcesLimit);
            var selectedResource = $scope.resources.filter(function (resource) {
                return resource.value === requestedLimit;
            })[0];

            if (!selectedResource || !selectedResource.locked) {
                $scope.lastAllowedResourcesLimit = requestedLimit;
                return;
            }

            $scope.schedule.resourcesLimit = $scope.lastAllowedResourcesLimit || snapToAllowed(requestedLimit);

            var requiredPlan = getPlanForResources(requestedLimit);
            if (requiredPlan && requiredPlan.annualAlias) {
                $state.go('upgrade.checkout', {alias: requiredPlan.annualAlias});
                return;
            }

            $state.go('upgrade.choose-plan', {type: 'agency'});
        }

            // TRACKING
            var stoTool = 'SEO Project';
            var eventLabel = $rootScope.stoFrom ? stoTool + ' - ' + $rootScope.stoFrom : stoTool;
            if ($scope.wizardMode) {
                CRMService.addEvents(['ProjectToConfigEvent'], [
                    'ProjectToCreateEvent',
                ]);

                TrackEventService.event(
                    'Suite Usages',
                    'SEO Project - Step - Schedule Audit', eventLabel);
                TrackEventService.gaV2Event(
                    'project_wizard', {
                        step: 'Schedule Audit',
                        from: $rootScope.stoFrom,
                        type: stoTool
                    });
            }
            //
            } catch (error) {
                $element.attr('data-oninit-error', (error && (error.stack || error.message)) || String(error));
            }
        };

        this.$onChanges = function () {
            $element.attr('data-onchanges-ran', 'true');
            syncBindings();
        };

        this.$postLink = function () {
            $element.attr('data-postlink-ran', 'true');
            syncBindings();
        };

    }

    controller.$inject = [
        '$scope',
        '$element',
        '$filter',
        '$mdMedia',
        '$translate',
        '$mdToast',
        '$stateParams',
        '$state',
        'TrackEventService',
        '$rootScope',
        'UserService',
        '$q',
        'TimezoneService',
        'PlanDetailsService',
        'CRMService'
    ];

    return {
        template: wizardTemplate,
        bindings: {
            schedule: '<',
            wizardMode: '<',
            viewMode: '<',
        },
        controller: controller
    };
});
